import type { OperationsAttentionSplitDto, OperationsLensKey } from "@/api/endpoints";

interface Props {
  split: OperationsAttentionSplitDto;
  /** Width scale: the largest row's total on the same panel. */
  max: number;
  title: string;
  /** Under a lens every item is in one state, so the bar is one segment in that state's colour. */
  lens?: OperationsLensKey;
  onClick?: () => void;
}

/**
 * A horizontal bar segmented Stuck / Blocked / Stuck + Blocked / Unknown / Clear, scaled to `max`.
 * One exclusive state per request, so the segments add up to the row's total.
 */
export function AttentionBar({ split, max, title, lens, onClick }: Props) {
  const seg = (cls: string, label: string, n: number) =>
    n > 0 ? <div key={cls} className={`ops-seg ${cls}`} style={{ width: `${((n / max) * 100).toFixed(2)}%` }} title={`${n} ${label}`} /> : null;
  return (
    <button type="button" className="ops-track" title={title} onClick={onClick} disabled={!onClick}>
      {lens ? (
        seg(`lens-${lens}`, lens, split.total)
      ) : (
        <>
          {seg("stuck", "stuck", split.stuck)}
          {seg("blocked", "blocked", split.blocked)}
          {seg("stuckAndBlocked", "stuck and blocked", split.stuckAndBlocked)}
          {seg("unknown", "unknown", split.unknown)}
          {seg("clear", "clear", split.clear)}
        </>
      )}
    </button>
  );
}

export function AttentionLegend() {
  return (
    <div className="ops-legend">
      <span><i className="ops-sw" style={{ background: "var(--ops-att-stuck)" }} />Stuck</span>
      <span><i className="ops-sw" style={{ background: "var(--ops-att-blocked)" }} />Blocked</span>
      <span><i className="ops-sw" style={{ background: "var(--ops-att-both)" }} />Stuck + Blocked</span>
      <span><i className="ops-sw" style={{ background: "var(--ops-att-clear)", border: "1px solid var(--border-subtle)" }} />Clear</span>
    </div>
  );
}
